import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  onMenuToggle: () => void;
  title?: string;
}

export default function Header({ onMenuToggle, title }: HeaderProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // API 호출
      await fetch("/api/auth/logout", {
        method: "POST",
      });

      // 프론트 상태/스토리지 초기화 (JWT 등 저장 중인 경우)
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");

      // 드롭다운 닫기
      setShowUserMenu(false);

      // 로그인 페이지로 이동
      navigate("/login");
    } catch (err) {
      console.error("로그아웃 중 오류:", err);
      navigate("/login");
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6">
      <div className="flex items-center">
        <button
          onClick={onMenuToggle}
          className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
        >
          <i className="ri-menu-line text-xl"></i>
        </button>
        {title && (
          <h1 className="ml-4 lg:ml-0 text-2xl font-semibold text-gray-900">
            {title}
          </h1>
        )}
      </div>

      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <button className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg relative">
          <i className="ri-notification-3-line text-xl"></i>
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* User menu */}
        <div className="relative">
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-lg"
          >
            <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center mr-2">
              <i className="ri-user-line text-gray-600"></i>
            </div>
            <i className="ri-arrow-down-s-line text-sm"></i>
          </button>

          {showUserMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                <i className="ri-user-line mr-2"></i>Profile
              </button>

              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
                <i className="ri-settings-line mr-2"></i>Settings
              </button>

              <hr className="my-1" />

              {/* 🔥 Logout */}
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
              >
                <i className="ri-logout-box-line mr-2"></i>Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
